
import React, { Fragment, useState, useMemo } from 'react';

import ModalHeader from '@common-components/headers/ModalHeader';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

const TagModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                id = null,
                name: tagName = '',
                tags,
                handleTagChange
            }
        },
        bottomAnchors: [
            anchor_1,
            anchor_2
        ],
        boundAnchor
    } = props;

    const [ name, updateTagName ] = useState(tagName);
    const trimmedLowerName = name.trim().toLowerCase();

    const isSaveDisabled = useMemo(
        () => tags.some(tag => tag.name.toLowerCase() === name.toLowerCase()) || trimmedLowerName.length === 0,
        [ name ]
    );

    const handleSave = () => {
        switch(true){
            case isSaveDisabled:
                return;
            default:
                handleTagChange({ id, name }, undefined); // undefined - for production; 'GET' - for localhost 8888
        }
    };

    const handleChange = ({ target: { value } }) => {
        if(value.length > 60) return;
        updateTagName(value);
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' data-testid = "tag_list_modal_header">
                <ModalHeader
                    { ...modalHeaderProps }
                    modalHeaderTextData = { id ? 'modals.tag_modal.edit_tag': 'modals.tag_modal.create_tag' }
                />
            </div>
            <div id= 'tagModal' className = 'gi-modal__body' data-testid = "tag_list_modal_body">
                <label className = 'gi-modal__input__label' htmlFor = "tag_list_modal_input">
                    <FormattedMessage id = 'modals.tag_name'/>
                </label>
                <input
                    value = { name }
                    onChange = { handleChange }
                    className = 'width-full gi-modal__input__field'
                    data-testid = "tag_list_modal_input"
                    id = "tag_list_modal_input"
                />
            </div>
            <div className = 'gi-modal__controls' data-testid = "tag_list_modal_controls">
                <Button
                    className = 'usa-button gi-button gi-button__secondary'
                    onClick = { hideModal }
                    inputRef = { boundAnchor(anchor_2) }
                    data-testid = "tag_list_modal_close_btn"
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    disabled = { isSaveDisabled }
                    onClick = { handleSave }
                    inputRef = { boundAnchor(anchor_1) }
                    data-testid = "tag_list_modal_save_btn"
                >
                    <FormattedMessage id = 'button.save'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default TagModal;